import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import VonageProvider from "components/Meeting/Live/VonageProvider";
import Routes from "components/_App/Routes";

import CloseIcon from "assets/icons/Close";

import SocketProvider from "./components/SocketProvider";

const CloseButton = ({ closeToast }: any) => (
  <button onClick={closeToast} type="button" className="toast-close">
    <CloseIcon width={32} height={32} />
  </button>
);

function App() {
  const { i18n } = useTranslation();
  const dir = i18n.dir();

  return (
    <VonageProvider>
      <SocketProvider>
        <Routes>
          <div className="toast-wrapper" dir={dir}>
            <ToastContainer
              position={dir === "ltr" ? "bottom-right" : "bottom-left"}
              // autoClose={false}
              closeButton={CloseButton}
            />
          </div>
        </Routes>
      </SocketProvider>
    </VonageProvider>
  );
}

export default App;
